import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d2aykgrbmk: FaireBrandEntity = {
  token: "b_d2aykgrbmk",
  type: "brand",
  name: "Just Made Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/63f31ce52c528b33678a7d50ce118489adeb68860e221c8b8d0949f991f40b8e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8ab78733110d16a7d4ad2798a541b657854ffde3c2e27d4dc3e5d84cbc270d11.png",
  logoUrl:
    "https://cdn.faire.com/fastly/63f31ce52c528b33678a7d50ce118489adeb68860e221c8b8d0949f991f40b8e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8ab78733110d16a7d4ad2798a541b657854ffde3c2e27d4dc3e5d84cbc270d11.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 45,
  isTopShop: true,
  isInsider: true,
  description:
    "While living and traveling in South America, founders\nof Just Made, Walter & Norka Nimocks, encountered a\nwide variety of tropical fruits.\n\nA few years later they returned to the United States with\na passion for sharing the “secrets of the tropics” with\ntheir family, friends and now you!\n\nWe believe in using business as a force for good. For\nevery bottle sold, we donate 5 to support local schools,\nteachers and students in rural Latin America and the\nCaribbean. Since 2016, we have invested in training,\nsupplies and basic infrastructure. The fund is managed\nby Just Made, so 100% of the money goes toward\nempowering our farming communities and their\nfamilies. Just Made. Made Justly. \n\nDiscover the Secrets of the Tropics with Just Made\ntropical juices. We start with traditional recipes from\nall across Latin America and the Caribbean,\nblend in functional ingredients and herbs, bottle and\nship from our facility in Houston, Texas. We reach any\npart of the country is less than 3 days! (For FTL orders)\n\nTropical fruits not only taste amazing, but they’re also\npacked with vitamins, antioxidants, and enzymes that\nstrengthen immune systems.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.368Z",
    importedBy: "entity-db-cli",
  },
};
